import React, { useState } from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Modal from '../Modal/Modal.js';
import './PhotoLoader.css';
import isEmpty from "lodash/isEmpty";
import Axios from 'axios';
import ReactDOM from "react-dom";

function useInfiniteScroll(callback) {
  const [isFetching, setIsFetching] = useState(false);

  React.useEffect(() => {
    function handleScroll() {
      if (window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight || isFetching) return;
      setIsFetching(true);
    }

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isFetching]);

  React.useEffect(() => {
    if (!isFetching) return;
    callback();
  }, [isFetching]);

  return [isFetching, setIsFetching];
}

class PhotoLoader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      photos: [],
      page: 1,
      perPage: 16,
      totalPages: 0,
      loading: true,
	  show: false,
	  showSpinner: true,
	  showPhoto: false,
	  isLoading: true,
      error: null,
	  photoClicked: function photoClicked(photoId, state) {
				
		var title = "";
		var url = "";		  
		  
		Axios.get('https://jsonplaceholder.typicode.com/photos/'+photoId, { crossdomain: true })
			  .then(response => {
				  title = response.data.title;
				  url = response.data.url;
				  const rootElementDetails = document.getElementById("modalPhoto");
			  
				  ReactDOM.render(
					  <div>
						<p>{title}</p>
						<Image src={url} className="PhotoLoader-large" fluid />
					  </div>,
					  rootElementDetails
				  );
			  });
	  }
    };
  }

  fetchPhotos = async () => {
    try {
      const { page, perPage } = this.state;
      const response = await fetch(`https://jsonplaceholder.typicode.com/photos?_page=${page}&_limit=${perPage}`);
      const data = await response.json();
      const totalPhotos = response.headers.get('x-total-count');
      const totalPages = Math.ceil(totalPhotos / perPage);
      this.setState(prevState => ({
        photos: [...prevState.photos, ...data],
        loading: false,
        totalPages,
      }));
    } catch (error) {
      this.setState({ error, loading: false });
    }
  };

  componentDidMount() {
    this.fetchPhotos();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page) {
      this.fetchPhotos();
    }
  }

  handleLoadMore = () => {
    this.setState(prevState => ({ page: prevState.page + 1 }));
  };

  showModal = () => {
	this.setState({ show: true });
	setTimeout(() => {
	  this.setState({ isLoading: false });
	  this.setState({ showSpinner: false });
	  this.setState({ showPhoto: true });
	}, 3600);
  };

  hideModal = () => {
	this.setState({ show: false });
	this.setState({ isLoading: true });
	this.setState({ showSpinner: true });
	this.setState({ showPhoto: false });
  };

  onClick(photoId, state) {
	this.state.photoClicked(photoId, state);
	this.showModal();
	//console.log(this.state.showSpinner);
  };

  render() {
    const { photos, loading, error, totalPages } = this.state;

    if (error) {
      return <div>Error: {error.message}</div>;
    }

    if (loading) {
      return <div>Loading...</div>;
    }

    return (
      <>
        <div className="App-photobrowser-grid">
	    <Container className="PhotoLoader-photobrowser-grid-container">
		  <div id="photos">
          {photos.map((photo) => (
            <Button key={photo.id+"_button"} className="PhotoLoader-photo-button" onClick={() => this.onClick(photo.id, this.state) }><Image key={photo.id+"_photo"} src={photo.thumbnailUrl} className="PhotoLoader-thumbnail" thumbnail></Image></Button>
          ))}
        </div>
        {totalPages > this.state.page && (
		<div className='More'>
          <Button className="PhotoLoader-button" variant="primary" onClick={this.handleLoadMore}>
            Load more photos
          </Button>
		</div>
        )}
		<Modal show={this.state.show} showSpinner={this.state.showSpinner} showPhoto={this.state.showPhoto} handleClose={this.hideModal}>
		      {
			    this.state.isLoading ? (
				  <Spinner animation="grow" className="PhotoLoader-modal-hidden" />
				) : !isEmpty(this.state.photos) ? (
				  <div></div>
				) : (
				  <div></div>
				)
			  }
		  </Modal>
		</Container>
		<div className="placer"></div>
	   </div>
      </>
    );
  }
}

export default PhotoLoader; 